<template>
    <ul class="cs_tabMenu">
        <li
            v-for="tab in tabs"
            :class="tab.idx === activeMenu ? 'active' : ''"
            @click="toPage(tab)"
        >{{ tab.name }}</li>
    </ul>
</template>

<script>

export default {
    data() {
        return {
            tabs: [
                { idx: 1, name: '장례식장 코드', pageName: 'ApiGuideFuneralPage', starter: '/api-guide/api-guide-funeral' },
                { idx: 2, name: '부고 캠페인', pageName: 'ApiGuideCampaignPage', starter: '/api-guide/api-guide-campaign' },
                { idx: 3, name: 'API 가이드', pageName: 'ApiGuideAuthPage', starter: '/api-guide/api-guide-auth' },
            ],
            activeMenu: 0
        }
    },

    methods: {
        toPage(tab) {
            if (tab.idx !== this.activeMenu) {
                this.$router.push({ name: tab.pageName})
            }
        },

        updateActiveMenu(currentPath) {
			for (const tab of this.tabs) {
			    const match = currentPath.startsWith(tab.starter);
                if (match) {
                    this.activeMenu = tab.idx
                    return;
                }
			}
			this.activeSubMenu = 0;
		},
    },

    watch: {
		$route(newRoute) {
			this.updateActiveMenu(newRoute.path);
		},
	},

	mounted() {
		this.updateActiveMenu(this.$route.path)
	}
    
}
</script>
<style lang="">
    
</style>
